import { Label } from "@bca/ui-library";
import React from "react";

import { ViewportSizeType } from "../../hooks/useViewport.hook";

interface VehicleLabelsPros {
  dataTestId: string;
  recentlyAddedBadge?: string | null;
  vrmNumber: string;
  lotNumber: string;
  viewportWidth?: ViewportSizeType;
}

const VehicleLabels: React.FunctionComponent<VehicleLabelsPros> = ({
  dataTestId,
  recentlyAddedBadge,
  vrmNumber,
  lotNumber,
  viewportWidth = "",
}) => {
  const desktopView =
    viewportWidth === "smallDesktop" || viewportWidth === "desktop";

  return (
    <>
      {desktopView && recentlyAddedBadge ? (
        <Label
          backgroundColor="secondary-green"
          label={recentlyAddedBadge}
          height="24px"
          marginRight="8px"
        />
      ) : null}
      <Label
        backgroundColor="primary-white"
        label={vrmNumber}
        leftEdgeColor="primary-light-blue"
        textColor="footer-blue"
        withShadow
        marginRight="10px"
        borderColor="lightest-grey"
        borderWidth="1px"
        borderStyle="solid"
        px={2}
      />
      {lotNumber?.length > 0 && lotNumber !== "" && lotNumber !== "0" && (
        <Label
          backgroundColor={
            desktopView ? "secondary-light-grey" : "rgba(255, 255, 255, 0.3)"
          }
          label={lotNumber}
          textColor={desktopView ? "footer-blue" : "primary-white"}
          data-testid={dataTestId}
          mt={viewportWidth === "mobile" ? "8px" : "0px"}
        />
      )}
    </>
  );
};

export default VehicleLabels;
